<template>
    <svg
        v-if="!gradient"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="4" y="3" width="13" height="14" fill="white" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.8 10C20.8 12.6522 19.7043 15.1957 17.7539 17.0711C15.8035 18.9464 13.1583 20 10.4 20C7.64175 20 4.99647 18.9464 3.04609 17.0711C1.09571 15.1957 0 12.6522 0 10C0 7.34784 1.09571 4.8043 3.04609 2.92893C4.99647 1.05357 7.64175 0 10.4 0C13.1583 0 15.8035 1.05357 17.7539 2.92893C19.7043 4.8043 20.8 7.34784 20.8 10ZM10.4 6.25C10.1716 6.24979 9.94715 6.30744 9.74928 6.41716C9.55142 6.52689 9.38711 6.6848 9.2729 6.875C9.19044 7.02235 9.07804 7.15227 8.94239 7.25708C8.80673 7.36188 8.65058 7.43943 8.48317 7.48513C8.31577 7.53082 8.14053 7.54374 7.96784 7.52311C7.79515 7.50248 7.62852 7.44872 7.47784 7.36501C7.32716 7.28131 7.19549 7.16937 7.09063 7.03584C6.98578 6.9023 6.90987 6.74987 6.86742 6.5876C6.82496 6.42533 6.81682 6.25652 6.84348 6.09117C6.87013 5.92582 6.93105 5.7673 7.0226 5.625C7.45188 4.91014 8.11448 4.35145 8.90763 4.03558C9.70078 3.7197 10.5802 3.6643 11.4094 3.87795C12.2386 4.0916 12.9714 4.56237 13.494 5.21725C14.0167 5.87213 14.3 6.67453 14.3 7.5C14.3002 8.27577 14.0503 9.03253 13.5847 9.66607C13.1191 10.2996 12.4606 10.7787 11.7 11.0375V11.25C11.7 11.5815 11.563 11.8995 11.3192 12.1339C11.0754 12.3683 10.7448 12.5 10.4 12.5C10.0552 12.5 9.72456 12.3683 9.48076 12.1339C9.23696 11.8995 9.1 11.5815 9.1 11.25V10C9.1 9.66848 9.23696 9.35054 9.48076 9.11612C9.72456 8.8817 10.0552 8.75 10.4 8.75C10.7448 8.75 11.0754 8.6183 11.3192 8.38388C11.563 8.14946 11.7 7.83152 11.7 7.5C11.7 7.16848 11.563 6.85054 11.3192 6.61612C11.0754 6.3817 10.7448 6.25 10.4 6.25ZM10.4 16.25C10.7448 16.25 11.0754 16.1183 11.3192 15.8839C11.563 15.6495 11.7 15.3315 11.7 15C11.7 14.6685 11.563 14.3505 11.3192 14.1161C11.0754 13.8817 10.7448 13.75 10.4 13.75C10.0552 13.75 9.72456 13.8817 9.48076 14.1161C9.23696 14.3505 9.1 14.6685 9.1 15C9.1 15.3315 9.23696 15.6495 9.48076 15.8839C9.72456 16.1183 10.0552 16.25 10.4 16.25Z"
            fill="#0E5425"
        />
    </svg>
    <svg
        v-else-if="disabled"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.6004 9.99478C19.6004 12.5409 18.589 14.9827 16.7886 16.783C14.9883 18.5834 12.5465 19.5948 10.0004 19.5948C7.45431 19.5948 5.01252 18.5834 3.21217 16.783C1.41182 14.9827 0.400391 12.5409 0.400391 9.99478C0.400391 7.4487 1.41182 5.0069 3.21217 3.20655C5.01252 1.4062 7.45431 0.394775 10.0004 0.394775C12.5465 0.394775 14.9883 1.4062 16.7886 3.20655C18.589 5.0069 19.6004 7.4487 19.6004 9.99478ZM10.0004 6.39478C9.78955 6.39457 9.58237 6.44992 9.39973 6.55525C9.21708 6.66058 9.06541 6.81218 8.95999 6.99478C8.88387 7.13623 8.78012 7.26096 8.6549 7.36157C8.52968 7.46218 8.38554 7.53663 8.23101 7.5805C8.07649 7.62437 7.91472 7.63677 7.75532 7.61696C7.59591 7.59715 7.4421 7.54554 7.30301 7.46519C7.16392 7.38484 7.04238 7.27738 6.94559 7.14918C6.8488 7.02098 6.77873 6.87465 6.73955 6.71888C6.70036 6.5631 6.69284 6.40103 6.71745 6.2423C6.74205 6.08356 6.79828 5.93138 6.88279 5.79478C7.27905 5.10851 7.89068 4.57217 8.62282 4.26893C9.35496 3.96569 10.1667 3.9125 10.9322 4.1176C11.6976 4.32271 12.374 4.77465 12.8564 5.40334C13.3388 6.03202 13.6004 6.80232 13.6004 7.59478C13.6006 8.33952 13.3699 9.06601 12.9401 9.6742C12.5103 10.2824 11.9025 10.7424 11.2004 10.9908V11.1948C11.2004 11.513 11.074 11.8183 10.8489 12.0433C10.6239 12.2683 10.3187 12.3948 10.0004 12.3948C9.68213 12.3948 9.37691 12.2683 9.15186 12.0433C8.92682 11.8183 8.80039 11.513 8.80039 11.1948V9.99478C8.80039 9.67652 8.92682 9.37129 9.15186 9.14625C9.37691 8.9212 9.68213 8.79478 10.0004 8.79478C10.3187 8.79478 10.6239 8.66835 10.8489 8.4433C11.074 8.21826 11.2004 7.91304 11.2004 7.59478C11.2004 7.27652 11.074 6.97129 10.8489 6.74625C10.6239 6.5212 10.3187 6.39478 10.0004 6.39478ZM10.0004 15.9948C10.3187 15.9948 10.6239 15.8683 10.8489 15.6433C11.074 15.4183 11.2004 15.113 11.2004 14.7948C11.2004 14.4765 11.074 14.1713 10.8489 13.9462C10.6239 13.7212 10.3187 13.5948 10.0004 13.5948C9.68213 13.5948 9.37691 13.7212 9.15186 13.9462C8.92682 14.1713 8.80039 14.4765 8.80039 14.7948C8.80039 15.113 8.92682 15.4183 9.15186 15.6433C9.37691 15.8683 9.68213 15.9948 10.0004 15.9948Z"
            fill="#F88C9E"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.6004 9.99478C19.6004 12.5409 18.589 14.9827 16.7886 16.783C14.9883 18.5834 12.5465 19.5948 10.0004 19.5948C7.45431 19.5948 5.01252 18.5834 3.21217 16.783C1.41182 14.9827 0.400391 12.5409 0.400391 9.99478C0.400391 7.4487 1.41182 5.0069 3.21217 3.20655C5.01252 1.4062 7.45431 0.394775 10.0004 0.394775C12.5465 0.394775 14.9883 1.4062 16.7886 3.20655C18.589 5.0069 19.6004 7.4487 19.6004 9.99478ZM10.0004 6.39478C9.78955 6.39457 9.58237 6.44992 9.39973 6.55525C9.21708 6.66058 9.06541 6.81218 8.95999 6.99478C8.88387 7.13623 8.78012 7.26096 8.6549 7.36157C8.52968 7.46218 8.38554 7.53663 8.23101 7.5805C8.07649 7.62437 7.91472 7.63677 7.75532 7.61696C7.59591 7.59715 7.4421 7.54554 7.30301 7.46519C7.16392 7.38484 7.04238 7.27738 6.94559 7.14918C6.8488 7.02098 6.77873 6.87465 6.73955 6.71888C6.70036 6.5631 6.69284 6.40103 6.71745 6.2423C6.74205 6.08356 6.79828 5.93138 6.88279 5.79478C7.27905 5.10851 7.89068 4.57217 8.62282 4.26893C9.35496 3.96569 10.1667 3.9125 10.9322 4.1176C11.6976 4.32271 12.374 4.77465 12.8564 5.40334C13.3388 6.03202 13.6004 6.80232 13.6004 7.59478C13.6006 8.33952 13.3699 9.06601 12.9401 9.6742C12.5103 10.2824 11.9025 10.7424 11.2004 10.9908V11.1948C11.2004 11.513 11.074 11.8183 10.8489 12.0433C10.6239 12.2683 10.3187 12.3948 10.0004 12.3948C9.68213 12.3948 9.37691 12.2683 9.15186 12.0433C8.92682 11.8183 8.80039 11.513 8.80039 11.1948V9.99478C8.80039 9.67652 8.92682 9.37129 9.15186 9.14625C9.37691 8.9212 9.68213 8.79478 10.0004 8.79478C10.3187 8.79478 10.6239 8.66835 10.8489 8.4433C11.074 8.21826 11.2004 7.91304 11.2004 7.59478C11.2004 7.27652 11.074 6.97129 10.8489 6.74625C10.6239 6.5212 10.3187 6.39478 10.0004 6.39478ZM10.0004 15.9948C10.3187 15.9948 10.6239 15.8683 10.8489 15.6433C11.074 15.4183 11.2004 15.113 11.2004 14.7948C11.2004 14.4765 11.074 14.1713 10.8489 13.9462C10.6239 13.7212 10.3187 13.5948 10.0004 13.5948C9.68213 13.5948 9.37691 13.7212 9.15186 13.9462C8.92682 14.1713 8.80039 14.4765 8.80039 14.7948C8.80039 15.113 8.92682 15.4183 9.15186 15.6433C9.37691 15.8683 9.68213 15.9948 10.0004 15.9948Z"
            fill="url(#paint0_linear_20566_16165)"
            fill-opacity="0.2"
            style="mix-blend-mode: multiply"
        />
        <defs>
            <linearGradient
                id="paint0_linear_20566_16165"
                x1="0.400391"
                y1="0.394775"
                x2="0.400391"
                y2="19.5948"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="white" stop-opacity="0.5" />
                <stop offset="1" stop-opacity="0.5" />
            </linearGradient>
        </defs>
    </svg>

    <svg
        v-else
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="12"
            cy="12"
            r="10"
            fill="url(#paint0_linear_24660_403461)"
        />
        <circle
            cx="12"
            cy="12"
            r="10"
            fill="url(#paint1_linear_24660_403461)"
            fill-opacity="0.2"
        />
        <circle cx="12" cy="12" r="10" stroke="white" stroke-width="1.4" />
        <path
            d="M10.125 8.875C10.125 7.83947 10.9645 7 12 7C13.0355 7 13.875 7.83947 13.875 8.875C13.875 9.56245 13.505 10.1635 12.9534 10.4899C12.478 10.7711 12 11.1977 12 11.75V13"
            stroke="white"
            stroke-width="1.4"
            stroke-linecap="round"
        />
        <circle cx="12" cy="16" r="1" fill="white" />
        <defs>
            <linearGradient
                id="paint0_linear_24660_403461"
                x1="2"
                y1="8.5"
                x2="23.1612"
                y2="11.828"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF385C" />
                <stop offset="0.326336" stop-color="#E61E4D" />
                <stop offset="0.558646" stop-color="#E31C5F" />
                <stop offset="0.796077" stop-color="#D70466" />
                <stop offset="0.913171" stop-color="#BD1E59" />
                <stop offset="1" stop-color="#BD1E59" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_24660_403461"
                x1="12"
                y1="2"
                x2="12"
                y2="22"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-opacity="0" />
                <stop offset="1" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "QuestionMarkInCircleIcon",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        gradient: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        return {};
    },
});
</script>
